module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/fancy-box/sample-fancy-image-gallery/sample-fancy-image-gallery.component.scss
// module id = ./src/app/features/fancy-box/sample-fancy-image-gallery/sample-fancy-image-gallery.component.scss
// module chunks = main